import EventBus from './event-bus'
import { find, isUndefined, isNil, isEqual, get } from 'lodash'
import parseError from './mixin-parse-error-message'
import { FIELD_PROPS, FIELD_REQUIRED_LEVELS } from '../consts'
import { ERROR_MSG_TYPE } from '../utils'

const TYPE_INDEX = 'index'
const FIELD_ELEMENT_TARGET_RE = /(field\d+)|(id_\d+(_\d+)*)/g

export default {
  mixins: [parseError],
  data() {
    return {
      validateBeforeSave: false,
      fieldList: {},
    }
  },
  methods: {
    frontEndValidation(event) {
      if (this.submitType !== TYPE_INDEX) {
        if (!this.saveOnEnter && get(event, 'keyCode') && isEqual(event.keyCode, 13)) return
        if (this.saveOnEnter && get(event, 'keyCode') && isEqual(event.keyCode, 13) && !this.submitType)
          this.submitType = 'save'
        this.validateBeforeSave = true
        this.clearErrorClasses()
        if (this.field && this.field.type === 'subform') this.setSubFormFieldList()
        EventBus.$emit('subFormStoreValidate')
        EventBus.$emit('frontendValidate', 'frontendValidateAll')
      } else {
        this.clearErrorClasses()
        this.showMessages = false
        this.onSubmit()
      }
    },
    setSubFormFieldList() {
      for (const field of this.$validator._base.fields.items) {
        if (/(FIELD\d+)|(\[\d+])/g.test(field.name) && Object.entries(field.rules).length) {
          if (!this.fieldList.hasOwnProperty(field.name)) {
            this.fieldList[field.name] = 'invalid'
          }
        }
      }
    },
    /**
     *
     * @param fieldName
     */
    afterValidate(fieldName) {
      this.$nextTick(() => {
        delete this.fieldList[fieldName]
        if (this.validateBeforeSave && !Object.values(this.fieldList).includes('invalid')) {
          if (this.errors.items.length > 0) {
            this.errorMessages = this.transformErrors()
            if (isUndefined(find(this.errorMessages, { type: 'error' }))) {
              if (this.subForm) {
                this.saveSubForm()
              } else {
                this.onSubmit()
              }
            } else {
              this.showMessages = true
            }
          } else {
            this.clearErrorClasses()
            this.errorMessages = []
            if (this.subForm) {
              this.saveSubForm()
            } else {
              this.onSubmit()
            }
          }
          this.validateBeforeSave = false
        }
      })
    },
    clearErrorClasses() {
      const invalidElements = Array.from(document.getElementsByClassName('error'))
      if (invalidElements.length) {
        for (const element of invalidElements) {
          if (element.classList) element.classList.remove('error') // Yes, there are still cases with undefined classLists at this point
        }
      }
    },
    /**
     *
     * @param item
     * @param itemName
     * @param error
     * @param errorSchema
     */
    buildErrorOf(item, itemName, error, errorSchema) {
      let msg = error.msg
      errorSchema.fieldName = itemName
      errorSchema.fieldLabel = item.label
      errorSchema.hidden = Boolean(
        item.hidden || errorSchema.groupHidden || errorSchema.pageHidden || errorSchema.subFormHidden,
      )
      const errorRules = ['min', 'max', 'min_value', 'max_value']

      const requiredErrorLevel = get(item, FIELD_PROPS.REQUIRED, FIELD_REQUIRED_LEVELS.NONE)
      if (error.rule === FIELD_PROPS.REQUIRED) {
        if (requiredErrorLevel === FIELD_REQUIRED_LEVELS.WARNING) {
          errorSchema.errorType = ERROR_MSG_TYPE.WARNING
        } else if (requiredErrorLevel === FIELD_REQUIRED_LEVELS.ERROR) {
          errorSchema.errorType = ERROR_MSG_TYPE.ERROR
        } else {
          errorSchema.errorType = ''
        }
      }
      if (errorRules.includes(error.rule)) {
        errorSchema.errorType = ERROR_MSG_TYPE.ERROR
      }

      if (item.type === 'subform') {
        if (
          (this.isMinValue(error.rule) && this.recordNumberMismatch(item, error.rule)) ||
          (this.isMaxValue(error.rule) && this.recordNumberMismatch(item, error.rule))
        ) {
          errorSchema.errorType = requiredErrorLevel === FIELD_REQUIRED_LEVELS.ERROR
            ? ERROR_MSG_TYPE.ERROR
            : ERROR_MSG_TYPE.WARNING
          msg = msg.replace('field', 'subform')
          msg = msg.replace('be', 'contain')
          msg = msg.replace('.', ' records.')
        }
      }
      errorSchema.fieldType = item.type
      errorSchema.message = msg.replace(`${this.$storeNamespace}-`, '')
    },
    isMinValue(type) {
      return type === 'min_value'
    },
    isMaxValue(type) {
      return type === 'max_value'
    },
    recordNumberMismatch(item, type) {
      let ret
      switch (type) {
        case 'min_value':
          ret = item.validations && item.validations.min_value && item.subForm.rows.length < item.validations[type]
          break
        case 'max_value':
          ret = item.validations && item.validations.min_value && item.subForm.rows.length > item.validations[type]
          break
      }
      return ret
    },
    transformErrors() {
      let transformed = []
      for (const error of this.errors.items) {
        let errorSchema = {}
        this.form.pages &&
          this.form.pages.forEach((page) => {
            errorSchema.pageHidden = Boolean(page.hidden)
            page.groups &&
              page.groups.forEach((group) => {
                errorSchema.groupHidden = Boolean(group.hidden)
                group.rows &&
                  group.rows.forEach((row) => {
                    row &&
                      row.forEach((field) => {
                        if (field.type === 'subform') {
                          if (`${this.$storeNamespace}-${field.name}` === error.field) {
                            this.buildErrorOf(field, field.name, error, errorSchema)
                          }
                          field.subForm.rows &&
                            field.subForm.rows.forEach((row, idx) => {
                              row.items &&
                                row.items.forEach((item) => {
                                  const itemName = `${field.subIdForm}-${item.name}[${idx}]`
                                  if (`${this.$storeNamespace}-${itemName}` === error.field) {
                                    errorSchema.subFormItem = true
                                    errorSchema.subFormHidden = field.hidden
                                    errorSchema.subIdForm = field.subIdForm
                                    errorSchema.selector = `${item.name}[${idx}]`
                                    if (item.type === 'dropdownlist') {
                                      errorSchema.dropdown = true
                                    }
                                    this.buildErrorOf(item, itemName, error, errorSchema)
                                  }
                                })
                            })
                        } else if (`${this.$storeNamespace}-${field.id}` === error.field) {
                          this.buildErrorOf(field, field.name, error, errorSchema)
                        }
                      })
                  })
              })
          })
        const fieldTargetName = error.msg.match(FIELD_ELEMENT_TARGET_RE)
        let node
        if (errorSchema.hasOwnProperty('selector')) {
          node = document.querySelector(
            `#${CSS.escape(this.$get('idForm'))} [name='${errorSchema.subIdForm}-${errorSchema.selector}'] div`,
          )
        } else {
          node =
            fieldTargetName &&
            document.querySelector(`#${CSS.escape(this.$get('idForm'))} [id='${fieldTargetName[0]}-tooltip-target']`)
        }
        if (!isNil(node) && error.field.match(this.$storeNamespace)) node.classList.add('error')
        const message = {
          target: fieldTargetName,
          fieldType: errorSchema.fieldType,
          name: errorSchema.fieldName,
          label: errorSchema.fieldLabel,
          msg: errorSchema.message,
          rule: error.rule,
          type: errorSchema.errorType,
          subIdForm: errorSchema.subIdForm ? errorSchema.subIdForm : false,
        }
        if (!errorSchema.hidden && message.label) transformed.push(message)
      }
      return transformed
    },
  },
  mounted() {
    //Listen on the EventBus for changers to the child components error bag and merge in/remove errors
    EventBus.$on('errors-changed', (fieldName) => {
      this.afterValidate(fieldName)
      //this.errors = newErrors
    })
  },
  beforeDestroy() {
    EventBus.$off('errors-changed')
  },
}
